import { render, staticRenderFns } from "./1.vue?vue&type=template&id=bf4c601c&scoped=true&"
import script from "./1.vue?vue&type=script&lang=js&"
export * from "./1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4c601c",
  null
  
)

export default component.exports